module.exports = __webpack_public_path__ + "static/img/The-Victoria-Hotel.2ed7cad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/The-Victoria-Hotel.jpg
// module id = la81
// module chunks = 0